import { render, staticRenderFns } from "./CierreNovedadIndex.vue?vue&type=template&id=1cb54669"
import script from "./CierreNovedadIndex.vue?vue&type=script&lang=js"
export * from "./CierreNovedadIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports